

import { atom , useRecoilValue, useSetRecoilState, useResetRecoilState} from "recoil";


const stockAtomList = atom({key:'stockAdjustment', default:{Stock_Adjustment_Info:[],
    Warehouse:[]
}});

const stockEditAtom = atom({key:'stockAdjustmentEdit', default:{adjustment_main: [],
    adjustment_details: []}});




export  const SetStockAdjustmentList = () => useSetRecoilState(stockAtomList);
export  const GetStockAdjustmentList = () => useRecoilValue(stockAtomList);

export  const SetStockAdjustmentEdit = () => useSetRecoilState(stockEditAtom);
export  const GetStockAdjustmentEdit = () => useRecoilValue(stockEditAtom);
export const ResetAdjustmentEdit = ()=> useResetRecoilState(stockEditAtom);









